<!--
 * @Description:潜在客户
 * @Author: cxh
 * @Date: 2022-06-10 13:33:54
 * @LastEditTime: 2023-03-31 17:51:02
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <a-tabs v-model:activeKey="queryForm.dataPermissionType" @change="search">
        <a-tab-pane :key="undefined" :tab="t('common.all')"> </a-tab-pane>
        <a-tab-pane :key="1" :tab="t('custom.myCustomers')" force-render> </a-tab-pane>
        <a-tab-pane :key="2" :tab="t('custom.subordinateCustomers')"> </a-tab-pane>
      </a-tabs>
      <cos-table
        rowKey="cosId"
        :row-selection="{ onChange: onSelectChange }"
        :columns="columns"
        tableId="DcCosOfbuPotential"
        @fetch="fetch"
        @mask="showMask"
        v-model:search="queryForm"
        ref="tableRef"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item :label="t('custom.customerStatus')">
              <CosSelect
                v-model:value="queryForm.status"
                allowClear
                :placeholder="t('common.pleaseSelect')"
                mode="multiple"
                :options="dataConfig.potentialStatusEnum"
              />
            </dc-form-item>
            <dc-form-item :label="t('custom.customerName')">
              <a-input v-model:value="queryForm.customerName" allowClear :placeholder="t('common.pleaseInput')" />
            </dc-form-item>
            <dc-form-item :label="t('custom.remanentFollowDayType')">
              <CosSelect
                v-model:value="queryForm.remanentFollowDayType"
                allowClear
                :placeholder="t('common.pleaseSelect')"
                :options="dataConfig.remanentFollowDayTypeEnum"
              />
            </dc-form-item>
            <dc-form-item :label="t('custom.turnedPotentialTime')">
              <cos-range-picker
                v-model:startTime="queryForm.turnedPotentialStart"
                v-model:endTime="queryForm.turnedPotentialEnd"
              />
            </dc-form-item>
            <dc-form-item :label="t('custom.arkCode')">
              <a-input v-model:value="queryForm.arkCode" allowClear :placeholder="t('common.pleaseInput')" />
            </dc-form-item>
            <dc-form-item :label="t('common.contactMethod')">
              <a-input-group compact>
                <a-select
                  v-model:value="queryForm.contact.type"
                  style="width: 33%"
                  :placeholder="t('common.pleaseSelect')"
                >
                  <a-select-option :value="1">{{ t('common.mobile') }}</a-select-option>
                  <a-select-option :value="2">{{ t('common.email') }}</a-select-option>
                  <a-select-option :value="3">{{ t('common.skype') }}</a-select-option>
                </a-select>
                <a-input
                  v-model:value="queryForm.contact.keyword"
                  style="width: 67%"
                  :placeholder="t('common.pleaseInput')"
                />
              </a-input-group>
            </dc-form-item>
            <dc-form-item :label="t('custom.followerName')">
              <UserSelect v-model:value="queryForm.sellerList" :placeholder="t('common.pleaseSelect')" allowClear mode="multiple"/>
            </dc-form-item>
            <dc-form-item :label="t('custom.receiveTime')">
              <cos-range-picker v-model:startTime="queryForm.receiveStart" v-model:endTime="queryForm.receiveEnd" />
            </dc-form-item>
            <dc-form-item :label="t('custom.cosId')">
              <a-input v-model:value="queryForm.cosId" allowClear :placeholder="t('common.pleaseInput')" />
            </dc-form-item>
            <dc-form-item :label="t('custom.notFollowDayNum')">
              <CosSelect
                v-model:value="queryForm.unfollowDayType"
                allowClear
                :placeholder="t('common.pleaseSelect')"
                :options="dataConfig.customerUnfollowDayTypeEnum"
              />
            </dc-form-item>
            <dc-form-item :label="t('custom.channel')">
              <a-input-group compact>
                <ParamCodeCascader
                  type="search"
                  v-model:ids="queryForm.channelList"
                  appId="cos_ofbu"
                  paramCode="ofbu_source_channel"
                  style="width: 33%"
                />
                <a-input
                  v-model:value="queryForm.channelExplain"
                  :maxlength="100"
                  style="width: 67%"
                  :placeholder="t('common.pleaseInput')"
                  allowClear
                />
              </a-input-group>
            </dc-form-item>
            <dc-form-item name="activityQrcodeId" :label="t('custom.marketActivity')">
              <CosSelect
                  v-model:value="queryForm.activityQrcodeId"
                  :options="marketOptions"
                  :placeholder="t('common.pleaseSelect')"
                  allowClear
                  optionFilterProp="label"
                  showSearch
              />
            </dc-form-item>
          </a-form>
        </template>
        <template #bodyCell="{ column, record, text }">
          <template v-if="column.dataIndex === 'customerName'">
            <div class="flex">
              <p class="time-out-flag" v-if="record.timeoutFlag === true">{{ t('enum.overDue') }}</p>
              <p class="new-list-flag" v-if="record.haveFollowFlag === false">New</p>
              <p class="black-list-flag" v-if="record.blackListFlag">{{ t('enum.blackList') }}</p>
              <router-link
                :to="`/ofbu/potential/view?cosId=${record.cosId}`"
                class="ant-table-cell-ellipsis"
                :title="text"
                >{{ text || '--' }}</router-link
              >
            </div>
          </template>
          <template v-if="column.dataIndex === 'channel'">
            <ChannelText appId="cos_ofbu" paramCode="ofbu_source_channel" :value="text" :desc="record.channelExplain" />
          </template>
          <template v-if="column.dataIndex === 'customerRegion'">
            <CustomerAreaCascaderText appId="cos_ofbu" :value="text" />
          </template>
          <template v-if="column.dataIndex === 'arkCode'">
            <p>{{ Array.isArray(text) && text.length > 0 ? text.join('、') : '--' }}</p>
          </template>
          <template v-if="column.dataIndex === '$business.annualSalesUnit'">
            <p>
              {{
                record.business?.annualSales
                  ? `${record.business.annualSales?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} ${text}`
                  : '--'
              }}
            </p>
          </template>
          <template v-if="column.dataIndex === 'dataIntegrity'">{{ `${text || 0}%` }}</template>
          <template v-if="column.dataIndex === 'warehousesAmount'">
            <p>
              {{
                record.business?.demandInfo?.warehouses
                  ? amount(record.business.demandInfo?.warehouses)
                      ?.toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  : '--'
              }}
            </p>
          </template>
          <template v-if="column.dataIndex === 'action'">
            <more-button>
              <a-button type="link" @click="handleSendLink(record)" v-permission="'ofbu_potential_send_link_btn'">{{
                t('btn.sendRegist')
              }}</a-button>
              <a-button
                type="link"
                v-permission="'ofbu_potential_account_activate_btn'"
                @click="handleActivateAccount(record)"
                :disabled="!record.customerNumber || record.oaAuditStatus === '20' || record.oaAuditStatus === '30'"
              >{{
                  t('btn.客户激活')
                }}</a-button>
<!--              <a-button type="link" @click="handleActivateAccount(record)" v-permission="'ofbu_potential_account_activate_btn'">{{-->
<!--                  t('btn.客户激活')-->
<!--                }}</a-button>-->
<!--              <a-button type="link" @click="handlePerfect(record)" v-permission="'ofbu_potential_perfect_btn'">{{-->
<!--                t('btn.complete')-->
<!--              }}</a-button>-->
<!--              <a-button type="link" @click="handleSubContract(record)" v-permission="'ofbu_potential_contract_btn'">{{-->
<!--                t('btn.toContract')-->
<!--              }}</a-button>-->
              <a-button
                type="link"
                @click="handleFollowUp(record)"
                v-show="!record.blackListFlag"
                v-permission="'ofbu_potential_follow_add_btn'"
                >{{ t('btn.writeFollow') }}</a-button
              >
              <a-button type="link" @click="hanleAddVisitor(record)" v-permission="'ofbu_potential_visitor_add_btn'">{{
                t('btn.addVisitor')
              }}</a-button>
              <SellerButton
                type="link"
                :workCode="record.seller"
                @click="handleAddBuss(record)"
                v-permission="'ofbu_potential_buss_add_btn'"
                >{{ t('btn.addBussiess') }}</SellerButton
              >
              <a-button
                type="link"
                @click="handleAddCode(record)"
                v-show="!record.blackListFlag"
                v-permission="'ofbu_potential_code_add_btn'"
                >{{ t('btn.addArkCode') }}</a-button
              >
              <a-button
                type="link"
                @click="handleRelationCode(record)"
                v-show="!record.blackListFlag"
                v-permission="'ofbu_potential_code_relative_btn'"
                >{{ t('btn.relatedCode') }}</a-button
              >
              <a-button type="link" @click="handleEdit(record)" v-permission="'ofbu_potential_edit_btn'">{{
                t('btn.edit')
              }}</a-button>
              <a-button type="link" @click="handleDelete(record)" v-permission="'ofbu_potential_del_btn'">{{
                t('btn.del')
              }}</a-button>
            </more-button>
          </template>
        </template>
        <template #button>
          <a-button type="primary" @click="handleTransfer()" v-permission="'ofbu_potential_transfer_btn'">{{
            t('btn.transferCustomer')
          }}</a-button>
          <a-button @click="handleArchive()" v-permission="'ofbu_potential_archive_btn'">{{
            t('btn.archive')
          }}</a-button>
          <CosMergeButton
            v-permission="'ofbu_potential_customer_aggregation_merge_btn'"
            :data="selectedRows"
            appId="cos_ofbu"
            :fbuType="2"
            @success="success"
            >{{ t('btn.merge') }}</CosMergeButton
          >
          <ExportButton
            appId="cos_ofbu"
            taskType="403"
            :search="queryForm"
            v-permission="'ofbu_potential_export_btn'"
            >{{ t('btn.export') }}</ExportButton
          >
        </template>
      </cos-table>
      <!--发送注册链接--->
      <sendLinkModel ref="sendLinkModelRef" />
      <!--新增客户代码--->
      <addCodeModel ref="addCodeModelRef" @success="success" />
      <!--关联客户代码--->
      <relationCode ref="relationCodeRef" @success="success" />
      <!--转移客户--->
      <transferModel ref="transferModelRef" @success="success" />
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import { reactive, computed, onMounted, ref } from 'vue'
import CosMergeButton from '@/components/CosMergeButton'
import { potentialList, potentialDel, potentialDetail, potentialArchive } from '@/api/overseasSales/customerCenter'
import dataConfig from '@/views/overseasSales/commonEnum/dataConfig'
import relationCode from '../components/relationCode/index.vue'
import ChannelText from '@/components/CosCascaderText/components/channel.vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import addCodeModel from '@/views/overseasSales/customerCenter/accountCode/editModal.vue'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import sendLinkModel from '../components/sendLinkModel.vue'
import transferModel from '../components/transferModel.vue'
import { useRouter, useRoute } from 'vue-router'
import { Modal } from 'ant-design-vue'
import { message } from '@dc-platform/dc-components'
import { listByParamCodes } from '@/api/common'
import calc from '@/utils/calc'
import DCModal from '@/hooks/modalType'
import type { PotentialItem } from '@/typings/api/customerCenter'
import type { ParamCodeItem } from '@/typings/common'
import { useI18n } from 'vue-i18n'
import { cloneDeep } from 'lodash-es'
import { queryMarketActivityList } from '@/api/marketing/marketingManage'
import CosSelect from '@/components/Antd/CosSelect/index.vue'
const { t } = useI18n()
const router = useRouter()
const route = useRoute()
const tableRef = ref()
const sendLinkModelRef = ref()
const addCodeModelRef = ref()
const relationCodeRef = ref()
const transferModelRef = ref()
const selectedRows = ref<PotentialItem[]>([])
const queryForm = reactive({
  dataPermissionType: undefined,
  contact: {
    type: 1
  },
  stage: 2 // 2 潜在 3签约 4成交
})
const paramCodeData = reactive<{
  [key: string]: ParamCodeItem[]
}>({
  ofbu_sales_category: [], // 销售品类
  ofbu_product_type: [], // 货物类型
  ofbu_warehouse: [], // 合作海外仓
  ofbu_sale_platform: [], // 在售电商平台
  ofbu_service_demand: [], // 服务需求
  ofbu_demand_info: [], // 需求海外仓
  ofbu_erp_info: [], // 目前使用ERP
  ofbu_replenish_frequency: [], // 头程补货频次
  ofbu_business_type: [], // 客户业务类型
  ofbu_marketing_activity: [], // 关联市场活动
  ofbu_customer_size: [], // 客户规模
  ofbu_services_standard: [], // 服务标准
  ofbu_currency: [], // 币种
  ofbu_sales_channel: [], // 销售渠道
  ofbu_service_type: [], // 尾程服务需求
  ofbu_inbound_package_type: [], // 入库包装方式
  ofbu_sku_unit: [], // sku单位
  ofbu_client_type: [] // 客户业务类型
})
const marketOptions = ref<any[]>([])
const getMarketOption = () => {
  queryMarketActivityList({ subdomain: 'cos_ofbu' }).then((res) => {
    if (res.data && res.data.length) {
      marketOptions.value = res.data.map((item: any) => ({
        label: item.activityName,
        value: item.id
      }))
    }
  })
}
onMounted(() => {
  getByParamCodes()
  getMarketOption()
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: [
      'ofbu_sales_category',
      'ofbu_product_type',
      'ofbu_warehouse',
      'ofbu_sale_platform',
      'ofbu_service_demand',
      'ofbu_demand_info',
      'ofbu_erp_info',
      'ofbu_replenish_frequency',
      'ofbu_business_type',
      'ofbu_marketing_activity',
      'ofbu_customer_size',
      'ofbu_services_standard',
      'ofbu_currency',
      'ofbu_sales_channel',
      'ofbu_service_type',
      'ofbu_inbound_package_type',
      'ofbu_sku_unit',
      'ofbu_client_type'
    ]
  }).then((res) => {
    if (res.code === 200) {
      Object.assign(paramCodeData, res.data)
    }
  })
}
const search = () => {
  tableRef.value.search()
}
// 获取列表
const fetch = (queryForm: object, callBack: (res: any) => void) => {
  const params = cloneDeep(queryForm)
  const cosIds = params.cosId?.split(/[,，\s\n]/).filter((e: string) => e)
  const arkCodes = params.arkCode?.split(/[,，\s\n]/).filter((e: string) => e)
  if (cosIds && cosIds.length > 1) {
    params.cosIdList = cosIds
    delete params.cosId
  }
  if (arkCodes && arkCodes.length > 1) {
    params.arkCodeList = arkCodes
    delete params.arkCode
  }
  potentialList({
    ...params
  }).then((res) => {
    callBack(res)
  })
}
// 获取掩码信息
const showMask = (record: PotentialItem, callBack: (res: any) => void) => {
  potentialDetail(record.cosId).then((res) => {
    callBack(res.data.contact)
  })
}
// 算总额
const amount = (v: []) => {
  if (v && v.length) {
    const result = v.reduce((prev: number, curr: any) => calc.Add(prev, Number(curr.amount) || 0), 0)
    return result || 0
  }
  return 0
}

const onSelectChange = (selectedRowKeys: string[], rows: PotentialItem[]) => {
  selectedRows.value = rows
}
// 转移客户
const handleTransfer = () => {
  transferModelRef.value.toggle(selectedRows.value)
}
// 归档
const handleArchive = (row?: PotentialItem) => {
  const ids: any[] = selectedRows.value?.map((item) => item.cosId)
  if (!ids || ids.length < 1) {
    message.error(t('tips.chooseData'))
    return
  }
  DCModal.switch({
    title: t('tips.Ye9Qb3'),
    onOk() {
      potentialArchive({ cosIdList: ids }).then(() => {
        message.success(t('tips.7bMTZIE'))
        success()
      })
    }
  })
}
// 删除
const handleDelete = (row: PotentialItem) => {
  DCModal.delete({
    content: t('custom.CUn3xat3', { customerName: row.customerName }),
    onOk() {
      potentialDel({ cosIdList: [row.cosId] }).then(() => {
        message.success(t('tips.delSuccess'))
        tableRef.value.delFetch()
      })
    }
  })
}
// 关联客户代码
const handleRelationCode = (row: PotentialItem) => {
  relationCodeRef.value.toggle(row)
}
// 新增关联代码
const handleAddCode = (row: PotentialItem) => {
  addCodeModelRef.value.toggle({
    cosId: row.cosId
  })
}
// 编辑
const handleEdit = (row: PotentialItem) => {
  router.push({
    path: '/ofbu/potential/edit',
    query: {
      cosId: row.cosId
    }
  })
}
// 完善资料
const handlePerfect = (row: PotentialItem) => {
  router.push({
    path: '/ofbu/potential/perfect',
    query: {
      cosId: row.cosId
    }
  })
}
// 写跟进
const handleFollowUp = (row: PotentialItem) => {
  router.push({
    path: '/ofbu/followUpRecord/add',
    query: {
      followRefId: row.cosId,
      returnPath: route.fullPath
    }
  })
}
// 写商机
const handleAddBuss = (row: PotentialItem) => {
  router.push({
    path: '/ofbu/business/add',
    query: {
      saleChanceRefId: row.cosId
    }
  })
}
// 新增访客计划
const hanleAddVisitor = (row: PotentialItem) => {
  router.push({
    path: '/ofbu/visitorProgram/add',
    query: {
      saleChanceRefId: row.cosId
    }
  })
}
// 转签约
const handleSubContract = (row: PotentialItem) => {
  if (row.dataIntegrity !== 100) {
    Modal.confirm({
      title: t('custom.turnToContractModalTitle'),
      content: t('tips.EnS7LSHQ'),
      okText: t('btn.sure'),
      cancelText: t('btn.cancel'),
      onOk: () => {
        router.push({
          path: '/ofbu/potential/perfect',
          query: {
            cosId: row.cosId
          }
        })
      }
    })
  } else {
    router.push({
      path: '/ofbu/turnToContract',
      query: {
        cosId: row.cosId
      }
    })
  }
}
// 发送注册链接
const handleSendLink = (row: PotentialItem) => {
  sendLinkModelRef.value.toggle(row)
}
// 客户激活
const handleActivateAccount = (row: PotentialItem) => {
  router.push({ path: '/ofbu/accountActivation/add', query: { cosId: row.cosId } })
}
const success = (type = 'edit') => {
  if (type === 'add') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}
// 36
const columns = computed(() => [
  {
    title: t('custom.customerName'),
    dataIndex: 'customerName',
    width: 200,
    fixed: 'left'
  },
  { title: t('custom.cosId'), dataIndex: 'cosId', width: 200 },
  { title: t('custom.customerNumber'), dataIndex: 'customerNumber' },
  { title: t('custom.channel'), dataIndex: 'channel', width: 150 },
  { title: t('custom.potentialStatus'), dataIndex: 'status', dicData: dataConfig.potentialStatusEnum },
  { title: t('custom.customerRegion'), dataIndex: 'customerRegion' },
  { title: t('custom.followerName'), dataIndex: 'sellerName' },
  { title: t('custom.remanentFollowDayType'), dataIndex: 'remanentFollowDays' },
  { title: t('custom.notFollowDayNum'), dataIndex: 'unfollowDays' },
  { title: t('custom.arkCode'), dataIndex: 'arkCode' },
  { title: t('common.contactName'), dataIndex: ['contact', 'name'], cosType: 'mask' },
  { title: t('common.mobile'), dataIndex: ['contact', 'mobile'], cosType: 'mask' },
  { title: t('common.skype'), dataIndex: ['contact', 'skype'], cosType: 'mask' },
  { title: t('common.email'), dataIndex: ['contact', 'email'], cosType: 'mask' },
  { title: t('common.sex'), dataIndex: ['contact', 'sex'], dicData: dataConfig.genderEnum },
  { title: t('common.jobRole'), dataIndex: ['contact', 'jobRole'], dicData: dataConfig.linkRoleTypeEnum },
  { title: t('common.jobDuty'), dataIndex: ['contact', 'jobDuty'] },
  { title: t('common.createTime'), dataIndex: 'createTime' },
  { title: t('custom.turnedPotentialTime'), dataIndex: 'turnedPotential', width: 190 },
  { title: t('custom.最后一次领取时间'), dataIndex: 'lastReceiveTime' },
  { title: t('custom.officialWeb'), dataIndex: 'officialWeb' },
  { title: t('custom.companyDetailedAddress'), dataIndex: 'customerAddress' },
  { title: t('custom.marketActivity'), dataIndex: 'activityQrcodeId', dicData: marketOptions.value },
  { title: t('custom.clientType'), dataIndex: 'clientType', dicData: paramCodeData.ofbu_client_type },
  {
    title: t('custom.annualSales'),
    dataIndex: ['business', 'annualSalesUnit'],
    dicData: paramCodeData.ofbu_currency,
    width: 140
  },
  {
    title: t('custom.salesChannel'),
    dataIndex: ['business', 'salesChannel'],
    dicData: paramCodeData.ofbu_sales_channel
  },
  {
    title: t('custom.customerBusinessType'),
    dataIndex: ['business', 'businessType'],
    dicData: paramCodeData.ofbu_business_type
  },
  {
    title: t('custom.服务标准'),
    dataIndex: ['business', 'serviceStandard'],
    dicData: paramCodeData.ofbu_services_standard
  },
  {
    title: t('custom.产品分类'),
    dataIndex: ['business', 'salesCategory'],
    dicData: paramCodeData.ofbu_sales_category
  },
  {
    title: t('custom.产品尺寸'),
    dataIndex: ['business', 'cargoType'],
    dicData: paramCodeData.ofbu_product_type
  },
  {
    title: t('custom.订单类型分布'),
    dataIndex: ['business', 'orderTypeDistribution']
  },
  {
    title: t('custom.单品多品订单比例'),
    dataIndex: ['business', 'orderDistribution']
  },
  {
    title: t('custom.SKU种类'),
    dataIndex: ['business', 'skuType']
  },
  {
    title: t('custom.尾程服务需求'),
    dataIndex: ['business', 'serviceType'],
    dicData: paramCodeData.ofbu_service_type
  },
  {
    title: t('custom.区域仓'),
    dataIndex: ['business', 'regionalWarehouse'],
    dicData: paramCodeData.ofbu_demand_info
  },
  {
    title: t('custom.平均在库体积'),
    dataIndex: ['business', 'averageInventoryVolume']
  },
  { title: t('custom.预计第一次来货时间'), dataIndex: ['business', 'firstInboundTime'] },
  {
    title: t('custom.入库包装方式'),
    dataIndex: ['business', 'inboundPackageType'],
    dicData: paramCodeData.ofbu_inbound_package_type
  },
  {
    title: t('custom.SKU单位'),
    dataIndex: ['business', 'skuUnit'],
    dicData: paramCodeData.ofbu_sku_unit
  },
  {
    title: t('common.action'),
    dataIndex: 'action',
    langWidth: {
      zh: 255,
      en: 340
    },
    fixed: 'right'
  }
])
</script>
<script lang="ts">
export default { name: 'DcCosOFbuPotential' }
</script>

<style scoped></style>
